import React from 'react';
import { Hero } from './components/Hero';
import { BrandCategory } from './components/BrandCategory';
import { Promotions } from './components/Promotions';
import { NewProducts } from './components/NewProducts';
import { BestSelling } from './components/BestSelling';
import { About } from './components/About';
import { Dealerships } from './components/Dealerships';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-[#D4AF37] selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <BrandCategory data-id="element-2" />
      <Promotions data-id="element-3" />
      <NewProducts data-id="element-4" />
      <BestSelling data-id="element-5" />
      <About data-id="element-6" />
      <Dealerships data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}